module.exports = __webpack_public_path__ + "static/media/thumbnail.d894cb8a.jpg";